// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container__-vy+Y","selected":"Pagination_selected__SZnuF","dots":"Pagination_dots__cl4a0"};